import {Component, OnInit, AfterViewInit} from '@angular/core';
import {Router} from '@angular/router';

import {MessageService} from 'primeng/components/common/messageservice';
import {GlobalService} from '../../../service/global.service';
import {ModalService} from '../../../service/modal.service';
import {FtaService} from '../../../service/fta.service';
import {PesquisasFiltroApiService} from '../../../service/api/pesquisas-filtro.api';
import {ResultadoFiltroFta, FiltroDadosFta, ResultadoFiltroLayout} from '../../../model/filtros';
import {UtilApi} from '../../../service/api/util.api';
import {
    FiltrosDeInstalacaoProduto,
    FiltroInstalacaoProduto,
    FiltroAlteracaoEstado,
    FiltroMetadata
} from './../../../model/filtros';
import {InstalacaoProduto, ItemConfiguracao} from '../../../model/catalogo';
import {FiltrosDeOperacao, FiltroOperacao, ResultadoFiltroOperacao} from './../../../model/filtros';
import {Operacao} from '../../../model/catalogo';
import {FiltroServico, FiltrosDeServico, ResultadoFiltroServico} from './../../../model/filtros';
import {Servico} from '../../../model/catalogo';
import {ArrayDashboard} from '../../../model/catalogo';
import {async} from 'q';
import {CatalogoApiService} from '../../../service/api/catalogo.api';
import {FiltrosDeLayout, FiltroLayout} from './../../../model/filtros';


@Component({
    selector: 'app-home-artefato',
    templateUrl: './home-artefato.component.html',
    styleUrls: ['./home-artefato.component.css']
})
export class HomeArtefatoComponent implements AfterViewInit {

    constructor(
        private router: Router,
        private globalService: GlobalService,
        public pesquisaService: PesquisasFiltroApiService,
        private catalogoService: CatalogoApiService,
        public modalService: ModalService
    ) {
    }

    listaArtefato1: any;
    listaArtefato2: any;
    listaArtefato3: any;
    pagina: number = 1;

    //instalacaoDetalhe: InstalacaoProduto = new InstalacaoProduto();
    instalacoesProdutoDespacho: Array<InstalacaoProduto> = new Array<InstalacaoProduto>();
    itensConfiguracaoDespacho: Array<ItemConfiguracao> = new Array<ItemConfiguracao>();
    operacoesDespacho: ResultadoFiltroOperacao = new ResultadoFiltroOperacao();
    servicosDespacho: ResultadoFiltroServico = new ResultadoFiltroServico();
    layoutDespacho: ResultadoFiltroLayout = new ResultadoFiltroLayout();

    instalacoesProdutoAprovacao: Array<InstalacaoProduto> = new Array<InstalacaoProduto>();
    itensConfiguracaoAprovacao: Array<ItemConfiguracao> = new Array<ItemConfiguracao>();
    operacoesAprovacao: ResultadoFiltroOperacao = new ResultadoFiltroOperacao();
    servicosAprovacao: ResultadoFiltroServico = new ResultadoFiltroServico();
    layoutAprovacao: ResultadoFiltroLayout = new ResultadoFiltroLayout();

    instalacoesProdutoExclusao: Array<InstalacaoProduto> = new Array<InstalacaoProduto>();
    itensConfiguracaoExclusao: Array<ItemConfiguracao> = new Array<ItemConfiguracao>();
    operacoesExclusao: ResultadoFiltroOperacao = new ResultadoFiltroOperacao();
    servicosExclusao: ResultadoFiltroServico = new ResultadoFiltroServico();
    layoutExclusao: ResultadoFiltroLayout = new ResultadoFiltroLayout();

    resultadogeralDespacho: Array<ArrayDashboard> = new Array<ArrayDashboard>();
    resultadogeralAprovacao: Array<ArrayDashboard> = new Array<ArrayDashboard>();
    resultadogeralExclusao: Array<ArrayDashboard> = new Array<ArrayDashboard>();

    loading1: boolean = true;
    loading2: boolean = true;
    loading3: boolean = true;


    async ngAfterViewInit() {
        this.filtraArtefatosDespacho();
    }


    navegarPara(destino) {
        switch (destino) {

            case 'produto-transmissao-arquivo':
                this.router.navigate(['/produto-transmissao-arquivo']);
                break;

            case 'artefato-instalacao-produto':
                this.router.navigate(['/artefato-instalacao-produto']);
                break;
            case 'artefato-operacao':
                this.router.navigate(['/artefato-operacao']);
                break;
            case 'artefato-servico':
                this.router.navigate(['/artefato-servico']);
                break;
            case 'artefato-layout-arquivo':
                this.router.navigate(['/artefato-layout-arquivo']);
                break;
        }
    }

    async filtrarInstalacaoProdutoDespacho() {
        this.pesquisaService.mudarPagina(this.pagina);
        let filtros = this.getFiltrosInstalaçãoProdutoDespacho();
        await this.pesquisaService.filtraInstalacaoProdutoPaginacaoPromise(filtros)
            .then(
                resultado => {
                    this.instalacoesProdutoDespacho = resultado.instalacoesProduto;
                }
            ).catch(error => {
                this.instalacoesProdutoDespacho = new Array<InstalacaoProduto>();
                this.globalService.loading = false;
                this.loading1 = false;

            });
    }

    async filtrarOperacaoDespacho() {
        this.pesquisaService.mudarPagina(this.pagina);
        await this.pesquisaService.filtraOperacaoPaginadoPromise(this.getFiltrosOperacaoDespacho())
            .then(
                listaItens => {
                    this.operacoesDespacho = listaItens as ResultadoFiltroOperacao;
                }
            ).catch(error => {
                this.operacoesDespacho = new ResultadoFiltroOperacao();
                this.globalService.loading = false;
                this.loading1 = false;

            });
    }

    async filtrarServicosDespacho() {
        this.pesquisaService.mudarPagina(this.pagina);
        await this.pesquisaService.filtraServicoPaginadoPromisse(this.getFiltrosServicoDespacho())
            .then(
                listaItens => {
                    this.servicosDespacho = listaItens as ResultadoFiltroServico;
                }
            ).catch(error => {
                this.servicosDespacho = new ResultadoFiltroServico();
                this.globalService.loading = false;
                this.loading1 = false;

            });
    }


    async filtrarLayoutDespacho() {
        this.pesquisaService.mudarPagina(this.pagina);
        await this.pesquisaService.filtraLayoutPaginadoPromise(this.getFiltrosLayoutDespacho())
            .then(
                listaItens => {

                    this.layoutDespacho = listaItens as ResultadoFiltroLayout;
                }
            ).catch(error => {
                this.layoutDespacho = new ResultadoFiltroLayout();
                this.globalService.loading = false;
                this.loading1 = false;

            });
    }


    UnificaInstalacaoProdutoDespacho() {
        if (this.instalacoesProdutoDespacho.length != undefined) {
            for (let i = 0; i < this.instalacoesProdutoDespacho.length; i++) {
                let resultado = new ArrayDashboard();
                resultado.tipo = 'Instalação de Produto';
                resultado.nome = this.instalacoesProdutoDespacho[i].nomeInstalacao;
                resultado.codigo = this.instalacoesProdutoDespacho[i].codigo;
                resultado.versao = this.instalacoesProdutoDespacho[i].versao;
                this.resultadogeralDespacho.push(resultado);
            }
        }
    }


    UnificaOperacoesDespacho() {
        if (this.operacoesDespacho.operacoes != undefined) {
            for (let i = 0; i < this.operacoesDespacho.operacoes.length; i++) {
                let resultado = new ArrayDashboard();
                resultado.tipo = 'Operação';
                resultado.nome = this.operacoesDespacho.operacoes[i].nome;
                resultado.codigo = this.operacoesDespacho.operacoes[i].codigo;
                resultado.versao = this.operacoesDespacho.operacoes[i].versao;
                this.resultadogeralDespacho.push(resultado);
            }
        }
    }


    UnificaServicosDespacho() {
        if (this.servicosDespacho.servicos != undefined) {
            for (let i = 0; i < this.servicosDespacho.servicos.length; i++) {
                let resultado = new ArrayDashboard();
                resultado.tipo = 'Serviço';
                resultado.nome = this.servicosDespacho.servicos[i].nome;
                resultado.codigo = this.servicosDespacho.servicos[i].codigo;
                resultado.versao = this.servicosDespacho.servicos[i].versao;
                this.resultadogeralDespacho.push(resultado);
            }
        }
    }


    UnificaLayoutDespacho() {
        if (this.layoutDespacho.layouts != undefined) {
            for (let i = 0; i < this.layoutDespacho.layouts.length; i++) {
                let resultado = new ArrayDashboard();
                resultado.tipo = 'Leiaute';
                resultado.nome = this.layoutDespacho.layouts[i].nome;
                resultado.codigo = this.layoutDespacho.layouts[i].codigo;
                resultado.versao = this.layoutDespacho.layouts[i].versao;
                this.resultadogeralDespacho.push(resultado);
            }
        }
    }

    getFiltrosInstalaçãoProdutoDespacho() {

        let filtros = new FiltrosDeInstalacaoProduto();
        let filtroInstalacaoProduto = new FiltroInstalacaoProduto();
        let filtroAlteracaoEstado = new FiltroAlteracaoEstado();
        let filtroMetadata = new FiltroMetadata();

        filtroMetadata.pagina = this.pagina;
        filtroMetadata.porPagina = 10;
        filtroInstalacaoProduto.codTipoEstado = 1;
        filtroAlteracaoEstado.codTipoEstado = 1;

        filtros.filtroInstalacaoProduto = filtroInstalacaoProduto;
        filtros.filtroAlteracaoEstado = filtroAlteracaoEstado;
        filtros.metadata = filtroMetadata;

        return filtros;
    }

    getFiltrosOperacaoDespacho() {
        let filtros = new FiltrosDeOperacao();
        let filtroOperacao = new FiltroOperacao();
        let filtroAlteracaoEstado = new FiltroAlteracaoEstado();
        let filtroMetadata = new FiltroMetadata();

        filtroMetadata.pagina = this.pagina;
        filtroMetadata.porPagina = 10;
        filtroOperacao.codTipoEstado = 1;
        filtroAlteracaoEstado.codTipoEstado = 1;


        filtros.filtroOperacao = filtroOperacao;
        filtros.filtroAlteracaoEstado = filtroAlteracaoEstado;
        filtros.metadata = filtroMetadata;

        return filtros;
    }


    getFiltrosServicoDespacho() {
        let filtros = new FiltrosDeServico();
        let filtroServico = new FiltroServico();
        let filtroAlteracaoEstado = new FiltroAlteracaoEstado();
        let filtroMetadata = new FiltroMetadata();

        filtroMetadata.pagina = this.pagina;
        filtroMetadata.porPagina = 10;
        filtroServico.codTipoEstado = 1;
        // filtro alteracao estado
        filtroAlteracaoEstado.codTipoEstado = 1;
        filtros.filtroServico = filtroServico;
        filtros.filtroAlteracaoEstado = filtroAlteracaoEstado;
        filtros.metadata = filtroMetadata;

        return filtros;
    }

    getFiltrosLayoutDespacho() {
        let filtros = new FiltrosDeLayout();
        let filtroLayout = new FiltroLayout();
        let filtroAlteracaoEstado = new FiltroAlteracaoEstado();
        let filtroMetadata = new FiltroMetadata();

        filtroMetadata.pagina = this.pagina;
        filtroMetadata.porPagina = 10;
        filtroLayout.codTipoEstado = 1;

        filtroAlteracaoEstado.codTipoEstado = 1;
        filtros.filtroLayout = filtroLayout;
        filtros.filtroAlteracaoEstado = filtroAlteracaoEstado;
        filtros.metadata = filtroMetadata;

        return filtros;
    }

    /**APROVAÇÃO*/

    /***********************************************************************************************************************************/
    getFiltrosInstalaçãoProdutoAprovacao() {

        let filtros = new FiltrosDeInstalacaoProduto();
        let filtroInstalacaoProduto = new FiltroInstalacaoProduto();
        let filtroAlteracaoEstado = new FiltroAlteracaoEstado();
        let filtroMetadata = new FiltroMetadata();

        filtroMetadata.pagina = this.pagina;
        filtroMetadata.porPagina = 10;
        filtroInstalacaoProduto.codTipoEstado = 2;
        filtroAlteracaoEstado.codTipoEstado = 2;

        filtros.filtroInstalacaoProduto = filtroInstalacaoProduto;
        filtros.filtroAlteracaoEstado = filtroAlteracaoEstado;
        filtros.metadata = filtroMetadata;

        return filtros;
    }

    getFiltrosOperacaoAprovacao() {
        let filtros = new FiltrosDeOperacao();
        let filtroOperacao = new FiltroOperacao();
        let filtroAlteracaoEstado = new FiltroAlteracaoEstado();
        let filtroMetadata = new FiltroMetadata();

        filtroMetadata.pagina = this.pagina;
        filtroMetadata.porPagina = 10;
        filtroOperacao.codTipoEstado = 2;
        filtroAlteracaoEstado.codTipoEstado = 2;


        filtros.filtroOperacao = filtroOperacao;
        filtros.filtroAlteracaoEstado = filtroAlteracaoEstado;
        filtros.metadata = filtroMetadata;

        return filtros;
    }


    getFiltrosServicoAprovacao() {
        let filtros = new FiltrosDeServico();
        let filtroServico = new FiltroServico();
        let filtroAlteracaoEstado = new FiltroAlteracaoEstado();
        let filtroMetadata = new FiltroMetadata();

        filtroMetadata.pagina = this.pagina;
        filtroMetadata.porPagina = 10;
        filtroServico.codTipoEstado = 2;

        filtroAlteracaoEstado.codTipoEstado = 2;
        filtros.filtroServico = filtroServico;
        filtros.filtroAlteracaoEstado = filtroAlteracaoEstado;
        filtros.metadata = filtroMetadata;

        return filtros;
    }

    getFiltrosLayoutAprovacao() {
        let filtros = new FiltrosDeLayout();
        let filtroLayout = new FiltroLayout();
        let filtroAlteracaoEstado = new FiltroAlteracaoEstado();
        let filtroMetadata = new FiltroMetadata();

        filtroMetadata.pagina = this.pagina;
        filtroMetadata.porPagina = 10;
        filtroLayout.codTipoEstado = 2;

        filtroAlteracaoEstado.codTipoEstado = 2;
        filtros.filtroLayout = filtroLayout;
        filtros.filtroAlteracaoEstado = filtroAlteracaoEstado;
        filtros.metadata = filtroMetadata;

        return filtros;
    }

    /*FILTRA APROVACAO */

    /************************************************************************************/

    async filtrarInstalacaoProdutoAprovacao() {
        this.pesquisaService.mudarPagina(this.pagina);
        let filtros = this.getFiltrosInstalaçãoProdutoAprovacao();
        await this.pesquisaService.filtraInstalacaoProdutoPaginacaoPromise(filtros)
            .then(
                resultado => {
                    this.instalacoesProdutoAprovacao = resultado.instalacoesProduto;
                }
            ).catch(error => {
                this.instalacoesProdutoAprovacao = new Array<InstalacaoProduto>();
                this.globalService.loading = false;
                this.loading2 = false;

            });
    }

    async filtrarOperacaoAprovacao() {
        this.pesquisaService.mudarPagina(this.pagina);
        await this.pesquisaService.filtraOperacaoPaginadoPromise(this.getFiltrosOperacaoAprovacao())
            .then(
                listaItens => {
                    this.operacoesAprovacao = listaItens as ResultadoFiltroOperacao;
                }
            ).catch(error => {
                this.operacoesAprovacao = new ResultadoFiltroOperacao();
                this.globalService.loading = false;
                this.loading2 = false;

            });
    }

    async filtrarServicosAprovacao() {
        this.pesquisaService.mudarPagina(this.pagina);
        await this.pesquisaService.filtraServicoPaginadoPromisse(this.getFiltrosServicoAprovacao())
            .then(
                listaItens => {
                    this.servicosAprovacao = listaItens as ResultadoFiltroServico;
                }
            ).catch(error => {
                this.servicosAprovacao = new ResultadoFiltroServico();
                this.globalService.loading = false;
                this.loading2 = false;

            });
    }

    async filtrarLayoutAprovacao() {
        this.pesquisaService.mudarPagina(this.pagina);
        await this.pesquisaService.filtraLayoutPaginadoPromise(this.getFiltrosLayoutAprovacao())
            .then(
                listaItens => {

                    this.layoutAprovacao = listaItens as ResultadoFiltroLayout;
                }
            ).catch(error => {
                this.layoutAprovacao = new ResultadoFiltroLayout();
                this.globalService.loading = false;
                this.loading1 = false;

            });
    }

    /******************************************************************************************** */
    UnificaInstalacaoProdutoAprovacao() {

        if (this.instalacoesProdutoAprovacao != undefined) {
            for (let i = 0; i < this.instalacoesProdutoAprovacao.length; i++) {
                let resultado = new ArrayDashboard();
                resultado.tipo = 'Instalação de Produto';
                resultado.nome = this.instalacoesProdutoAprovacao[i].nomeInstalacao;
                resultado.codigo = this.instalacoesProdutoAprovacao[i].codigo;
                resultado.versao = this.instalacoesProdutoAprovacao[i].versao;
                this.resultadogeralAprovacao.push(resultado);
            }
        }
    }


    UnificaOperacoesAprovacao() {
        if (this.operacoesAprovacao.operacoes != undefined) {
            for (let i = 0; i < this.operacoesAprovacao.operacoes.length; i++) {
                let resultado = new ArrayDashboard();
                resultado.tipo = 'Operação';
                resultado.nome = this.operacoesAprovacao.operacoes[i].nome;
                resultado.codigo = this.operacoesAprovacao.operacoes[i].codigo;
                resultado.versao = this.operacoesAprovacao.operacoes[i].versao;
                this.resultadogeralAprovacao.push(resultado);
            }
        }
    }


    UnificaServicosAprovacao() {

        if (this.servicosAprovacao.servicos != undefined) {
            for (let i = 0; i < this.servicosAprovacao.servicos.length; i++) {
                let resultado = new ArrayDashboard();
                resultado.tipo = 'Serviço';
                resultado.nome = this.servicosAprovacao.servicos[i].nome;
                resultado.codigo = this.servicosAprovacao.servicos[i].codigo;
                resultado.versao = this.servicosAprovacao.servicos[i].versao;
                this.resultadogeralAprovacao.push(resultado);

            }
        }
    }

    UnificaLayoutAprovacao() {
        if (this.layoutAprovacao.layouts != undefined) {
            for (let i = 0; i < this.layoutAprovacao.layouts.length; i++) {
                let resultado = new ArrayDashboard();
                resultado.tipo = 'Leiaute';
                resultado.nome = this.layoutAprovacao.layouts[i].nome;
                resultado.codigo = this.layoutAprovacao.layouts[i].codigo;
                resultado.versao = this.layoutAprovacao.layouts[i].versao;
                this.resultadogeralAprovacao.push(resultado);
            }
        }
    }

    /**********************************************************************************************************************************/
    /**EXCLUSAO*/

    /***********************************************************************************************************************************/
    getFiltrosInstalaçãoProdutoExclusao() {

        let filtros = new FiltrosDeInstalacaoProduto();
        let filtroInstalacaoProduto = new FiltroInstalacaoProduto();
        let filtroAlteracaoEstado = new FiltroAlteracaoEstado();
        let filtroMetadata = new FiltroMetadata();

        filtroMetadata.pagina = this.pagina;
        filtroMetadata.porPagina = 10;
        filtroAlteracaoEstado.codTipoEstado = 7;

        filtros.filtroInstalacaoProduto = filtroInstalacaoProduto;
        filtros.filtroAlteracaoEstado = filtroAlteracaoEstado;
        filtros.metadata = filtroMetadata;

        return filtros;
    }

    getFiltrosOperacaoExclusao() {
        let filtros = new FiltrosDeOperacao();
        let filtroOperacao = new FiltroOperacao();
        let filtroAlteracaoEstado = new FiltroAlteracaoEstado();
        let filtroMetadata = new FiltroMetadata();

        filtroMetadata.pagina = this.pagina;
        filtroMetadata.porPagina = 10;
        filtroAlteracaoEstado.codTipoEstado = 7;


        filtros.filtroOperacao = filtroOperacao;
        filtros.filtroAlteracaoEstado = filtroAlteracaoEstado;
        filtros.metadata = filtroMetadata;

        return filtros;
    }


    getFiltrosServicoExclusao() {
        let filtros = new FiltrosDeServico();
        let filtroServico = new FiltroServico();
        let filtroAlteracaoEstado = new FiltroAlteracaoEstado();
        let filtroMetadata = new FiltroMetadata();

        filtroMetadata.pagina = this.pagina;
        filtroMetadata.porPagina = 10;
        filtroAlteracaoEstado.codTipoEstado = 7;
        filtros.filtroServico = filtroServico;
        filtros.filtroAlteracaoEstado = filtroAlteracaoEstado;
        filtros.metadata = filtroMetadata;

        return filtros;
    }

    getFiltrosLayoutExclusao() {
        let filtros = new FiltrosDeLayout();
        let filtroLayout = new FiltroLayout();
        let filtroAlteracaoEstado = new FiltroAlteracaoEstado();
        let filtroMetadata = new FiltroMetadata();

        filtroMetadata.pagina = this.pagina;
        filtroMetadata.porPagina = 10;
        filtroAlteracaoEstado.codTipoEstado = 7;
        filtros.filtroLayout = filtroLayout;
        filtros.filtroAlteracaoEstado = filtroAlteracaoEstado;
        filtros.metadata = filtroMetadata;

        return filtros;
    }

    /*FILTRA Exclusao */

    /************************************************************************************/

    async filtrarInstalacaoProdutoExclusao() {
        this.pesquisaService.mudarPagina(this.pagina);
        let filtros = this.getFiltrosInstalaçãoProdutoExclusao();
        await this.pesquisaService.filtraInstalacaoProdutoPaginacaoPromise(filtros)
            .then(
                resultado => {
                    this.instalacoesProdutoExclusao = resultado.instalacoesProduto;
                }
            ).catch(error => {
                    this.instalacoesProdutoExclusao = new Array<InstalacaoProduto>();
                    this.globalService.loading = false;
                    this.loading3 = false;

                }
            );
    }

    async filtrarOperacaoExclusao() {
        this.pesquisaService.mudarPagina(this.pagina);
        await this.pesquisaService.filtraOperacaoPaginadoPromise(this.getFiltrosOperacaoExclusao())
            .then(
                listaItens => {
                    this.operacoesExclusao = listaItens as ResultadoFiltroOperacao;
                }
            ).catch(error => {
                this.operacoesExclusao = new ResultadoFiltroOperacao();
                this.globalService.loading = false;
                this.loading3 = false;

            });
    }

    async filtrarServicosExclusao() {
        this.pesquisaService.mudarPagina(this.pagina);
        await this.pesquisaService.filtraServicoPaginadoPromisse(this.getFiltrosServicoExclusao())
            .then(
                listaItens => {
                    this.servicosExclusao = listaItens as ResultadoFiltroServico;
                }
            ).catch(error => {
                this.servicosExclusao = new ResultadoFiltroServico();
                this.globalService.loading = false;
                this.loading3 = false;

            });
    }

    async filtrarLayoutExclusao() {
        this.pesquisaService.mudarPagina(this.pagina);
        await this.pesquisaService.filtraLayoutPaginadoPromise(this.getFiltrosLayoutExclusao())
            .then(
                listaItens => {

                    this.layoutExclusao = listaItens as ResultadoFiltroLayout;
                }
            ).catch(error => {
                this.layoutExclusao = new ResultadoFiltroLayout();
                this.globalService.loading = false;
                this.loading1 = false;

            });
    }

    /*********************************************************************************************/
    UnificaInstalacaoProdutoExclusao() {

        if (this.instalacoesProdutoExclusao != undefined) {
            for (let i = 0; i < this.instalacoesProdutoExclusao.length; i++) {
                let resultado = new ArrayDashboard();
                resultado.tipo = 'Instalação de Produto';
                resultado.nome = this.instalacoesProdutoExclusao[i].nomeInstalacao;
                resultado.codigo = this.instalacoesProdutoExclusao[i].codigo;
                resultado.versao = this.instalacoesProdutoExclusao[i].versao;
                this.resultadogeralExclusao.push(resultado);

            }
        }
    }


    UnificaOperacoesExclusao() {

        if (this.operacoesExclusao.operacoes != undefined) {
            for (let i = 0; i < this.operacoesExclusao.operacoes.length; i++) {
                let resultado = new ArrayDashboard();
                resultado.tipo = 'Operação';
                resultado.nome = this.operacoesExclusao.operacoes[i].nome;
                resultado.codigo = this.operacoesExclusao.operacoes[i].codigo;
                resultado.versao = this.operacoesExclusao.operacoes[i].versao;
                this.resultadogeralExclusao.push(resultado);
            }
        }
    }


    UnificaServicoExclusao() {

        if (this.servicosExclusao.servicos != undefined) {
            for (let i = 0; i < this.servicosExclusao.servicos.length; i++) {
                let resultado = new ArrayDashboard();
                resultado.tipo = 'Serviço';
                resultado.nome = this.servicosExclusao.servicos[i].nome;
                resultado.codigo = this.servicosExclusao.servicos[i].codigo;
                resultado.versao = this.servicosExclusao.servicos[i].versao;
                this.resultadogeralExclusao.push(resultado);

            }
        }
    }


    UnificaLayoutExclusao() {
        if (this.layoutExclusao.layouts != undefined) {
            for (let i = 0; i < this.layoutExclusao.layouts.length; i++) {
                let resultado = new ArrayDashboard();
                resultado.tipo = 'Leiaute';
                resultado.nome = this.layoutExclusao.layouts[i].nome;
                resultado.codigo = this.layoutExclusao.layouts[i].codigo;
                resultado.versao = this.layoutExclusao.layouts[i].versao;
                this.resultadogeralExclusao.push(resultado);
            }
        }
    }


    async filtraArtefatosDespacho() {

        await this.filtrarOperacaoDespacho();
        await this.filtrarServicosDespacho();
        await this.filtrarInstalacaoProdutoDespacho();
        await this.filtrarLayoutDespacho();
        this.resultadogeralDespacho = new Array<ArrayDashboard>();
        this.unificaDespacho();

    }

    async filtraArtefatosAprovacao() {

        await this.filtrarOperacaoAprovacao();
        await this.filtrarServicosAprovacao();
        await this.filtrarInstalacaoProdutoAprovacao();
        await this.filtrarLayoutAprovacao();
        this.resultadogeralAprovacao = new Array<ArrayDashboard>();
        this.unificaAprovacao();

    }


    async filtraArtefatosExclusao() {

        await this.filtrarOperacaoExclusao();
        await this.filtrarServicosExclusao();
        await this.filtrarInstalacaoProdutoExclusao();
        await this.filtrarLayoutExclusao();
        this.resultadogeralExclusao = new Array<ArrayDashboard>();
        this.unificaExclusao();

    }


    unificaExclusao() {
        this.UnificaInstalacaoProdutoExclusao();
        this.UnificaServicoExclusao();
        this.UnificaOperacoesExclusao();
        this.UnificaLayoutExclusao();
        this.loading3 = false;

    }

    unificaAprovacao() {
        this.UnificaInstalacaoProdutoAprovacao();
        this.UnificaServicosAprovacao();
        this.UnificaOperacoesAprovacao();
        this.UnificaLayoutAprovacao();
        this.loading2 = false;
        this.filtraArtefatosExclusao();
    }


    unificaDespacho() {
        this.UnificaInstalacaoProdutoDespacho();
        this.UnificaServicosDespacho();
        this.UnificaOperacoesDespacho();
        this.UnificaLayoutDespacho();
        this.loading1 = false;
        this.filtraArtefatosAprovacao();

    }


    aprovarArtefato(codigoArtefato: number, versaoArtefato: number, tipoArtefato: String) {


        switch (tipoArtefato) {
            case 'Leiaute':

                this.catalogoService.aprovaArtefatoFta(codigoArtefato, versaoArtefato, 'layout', 'LAYOUT aprovado')
                    .subscribe(resposta => {
                            this.modalService.exibirMensagem('Sucesso', 'Layout número <b>' + codigoArtefato + '</b> aprovado com sucesso!', 'Fechar');
                            this.modalService.incluirDadosGerados('despachoOk');
                            this.filtraArtefatosDespacho();
                        },
                        erro => {
                            this.globalService.loading = false;
                            this.modalService.exibirMensagem('Erro', 'Ocorreu um erro ao aprovar o Layout. Favor verifique sua conexão.', 'Fechar');
                        }
                    );
                break;

            case 'Instalação de Produto':


                this.catalogoService.aprovaArtefatoFta(codigoArtefato, versaoArtefato, 'instalacaoProduto', 'Instalacao aprovado')
                    .subscribe(resposta => {
                            this.modalService.exibirMensagem('Sucesso', 'Instalação número <b>' + codigoArtefato + '</b> aprovado com sucesso!', 'Fechar');
                            this.modalService.incluirDadosGerados('despachoOk');
                            this.filtraArtefatosDespacho();
                        },
                        erro => {
                            this.globalService.loading = false;
                            this.modalService.exibirMensagem('Erro', 'Ocorreu um erro ao aprovar o Operação. Favor verifique sua conexão.', 'Fechar');
                        }
                    );
                break;

            case 'Operação':

                this.catalogoService.aprovaArtefatoFta(codigoArtefato, versaoArtefato, 'operacao', 'Operacao aprovado')
                    .subscribe(resposta => {
                            this.modalService.exibirMensagem('Sucesso', 'Operação número <b>' + codigoArtefato + '</b> aprovado com sucesso!', 'Fechar');
                            this.modalService.incluirDadosGerados('despachoOk');
                            this.filtraArtefatosDespacho();
                        },
                        erro => {
                            this.globalService.loading = false;
                            this.modalService.exibirMensagem('Erro', 'Ocorreu um erro ao aprovar o Operação. Favor verifique sua conexão.', 'Fechar');
                        }
                    );
                break;

            case 'Serviço':

                this.catalogoService.aprovaArtefatoFta(codigoArtefato, versaoArtefato, 'servico', 'Servico aprovado')
                    .subscribe(resposta => {
                            this.modalService.exibirMensagem('Sucesso', 'Serviços número <b>' + codigoArtefato + '</b> aprovado com sucesso!', 'Fechar');
                            this.modalService.incluirDadosGerados('despachoOk');
                            this.filtraArtefatosDespacho();
                        },
                        erro => {
                            this.globalService.loading = false;
                            this.modalService.exibirMensagem('Erro', 'Ocorreu um erro ao aprovar o Serviço. Favor verifique sua conexão.', 'Fechar');
                        }
                    );

                break;


        }


    }


    despacharArtefato(codigoArtefato: number, versaoArtefato: number, tipoArtefato: String) {


        switch (tipoArtefato) {

            case 'Leiaute':

                this.catalogoService.despacharArtefatoFta(codigoArtefato, versaoArtefato, 'layout', 'LAYOUT despachado')
                    .subscribe(resposta => {
                            this.modalService.exibirMensagem('Sucesso', 'Layout número <b>' + codigoArtefato + '</b> despachado com sucesso!', 'Fechar');
                            this.modalService.incluirDadosGerados('despachoOk');
                            this.filtraArtefatosDespacho();
                        },
                        erro => {
                            this.globalService.loading = false;
                            this.modalService.exibirMensagem('Erro', 'Ocorreu um erro ao despachar o Layout. Favor verifique sua conexão.', 'Fechar');
                        }
                    );
                break;

            case 'Instalação de Produto':


                this.catalogoService.despacharArtefatoFta(codigoArtefato, versaoArtefato, 'instalacaoProduto', 'Instalacao despachado')
                    .subscribe(resposta => {
                            this.modalService.exibirMensagem('Sucesso', 'Instalação número <b>' + codigoArtefato + '</b> despachado com sucesso!', 'Fechar');
                            this.modalService.incluirDadosGerados('despachoOk');
                            this.filtraArtefatosDespacho();
                        },
                        erro => {
                            this.globalService.loading = false;
                            this.modalService.exibirMensagem('Erro', 'Ocorreu um erro ao despachar o Operação. Favor verifique sua conexão.', 'Fechar');
                        }
                    );
                break;

            case 'Operação':

                this.catalogoService.despacharArtefatoFta(codigoArtefato, versaoArtefato, 'operacao', 'Operacao despachado')
                    .subscribe(resposta => {
                            this.modalService.exibirMensagem('Sucesso', 'Operação número <b>' + codigoArtefato + '</b> despachado com sucesso!', 'Fechar');
                            this.modalService.incluirDadosGerados('despachoOk');
                            this.filtraArtefatosDespacho();
                        },
                        erro => {
                            this.globalService.loading = false;
                            this.modalService.exibirMensagem('Erro', 'Ocorreu um erro ao despachar o Operação. Favor verifique sua conexão.', 'Fechar');
                        }
                    );
                break;

            case 'Serviço':

                this.catalogoService.despacharArtefatoFta(codigoArtefato, versaoArtefato, 'servico', 'Servico despachado')
                    .subscribe(resposta => {
                            this.modalService.exibirMensagem('Sucesso', 'Serviços número <b>' + codigoArtefato + '</b> despachado com sucesso!', 'Fechar');
                            this.modalService.incluirDadosGerados('despachoOk');
                            this.filtraArtefatosDespacho();
                        },
                        erro => {
                            this.globalService.loading = false;
                            this.modalService.exibirMensagem('Erro', 'Ocorreu um erro ao despachar o Serviço. Favor verifique sua conexão.', 'Fechar');
                        }
                    );

                break;


        }


    }

    excluirArtefato(codigoArtefato: number, versaoArtefato: number, tipoArtefato: String) {
        switch (tipoArtefato) {

            case 'Leiaute':

                this.catalogoService.deletaArtefatoFta(codigoArtefato, versaoArtefato, 'layout', 'LAYOUT excluido')
                    .subscribe(resposta => {
                            this.modalService.exibirMensagem('Sucesso', 'Layout número <b>' + codigoArtefato + '</b> excluido com sucesso!', 'Fechar');
                            this.modalService.incluirDadosGerados('despachoOk');
                            this.filtraArtefatosDespacho();
                        },
                        erro => {
                            this.globalService.loading = false;
                            this.modalService.exibirMensagem('Erro', 'Ocorreu um erro ao excluir o Layout. Favor verifique sua conexão.', 'Fechar');
                        }
                    );
                break;

            case 'Instalação de Produto':

                this.catalogoService.deletaArtefatoFta(codigoArtefato, versaoArtefato, 'instalacaoProduto', 'Instalacao excluido')
                    .subscribe(resposta => {
                            this.modalService.exibirMensagem('Sucesso', 'Instalação número <b>' + codigoArtefato + '</b> excluído com sucesso!', 'Fechar');
                            this.modalService.incluirDadosGerados('despachoOk');
                            this.filtraArtefatosDespacho();
                        },
                        erro => {
                            this.globalService.loading = false;
                            this.modalService.exibirMensagem('Erro', 'Ocorreu um erro ao excluir o Operação. Favor verifique sua conexão.', 'Fechar');
                        }
                    );
                break;

            case 'Operação':

                this.catalogoService.deletaArtefatoFta(codigoArtefato, versaoArtefato, 'operacao', 'Operacao excluido')
                    .subscribe(resposta => {
                            this.modalService.exibirMensagem('Sucesso', 'Operação número <b>' + codigoArtefato + '</b> excluido com sucesso!', 'Fechar');
                            this.modalService.incluirDadosGerados('despachoOk');
                            this.filtraArtefatosDespacho();
                        },
                        erro => {
                            this.globalService.loading = false;
                            this.modalService.exibirMensagem('Erro', 'Ocorreu um erro ao excluir o Operação. Favor verifique sua conexão.', 'Fechar');
                        }
                    );
                break;

            case 'Serviço':

                this.catalogoService.deletaArtefatoFta(codigoArtefato, versaoArtefato, 'servico', 'Servico excluido')
                    .subscribe(resposta => {
                            this.modalService.exibirMensagem('Sucesso', 'Serviços número <b>' + codigoArtefato + '</b> excluído com sucesso!', 'Fechar');
                            this.modalService.incluirDadosGerados('despachoOk');
                            this.filtraArtefatosDespacho();
                        },
                        erro => {
                            this.globalService.loading = false;
                            this.modalService.exibirMensagem('Erro', 'Ocorreu um erro ao excluír o Serviço. Favor verifique sua conexão.', 'Fechar');
                        }
                    );

                break;


        }


    }


}








// WEBPACK FOOTER //
// ./src/app/artefato/home-artefato/home-artefato.component.ts